import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl } from '@mui/material'
import axios from 'axios'
import { convertForBackend } from 'c1-i18n'
import { ReactElement, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { LanguageDropdown } from '../../Common/LanguageDropdown'

export interface LanguageDialogProps {
  onClose: () => void,
  open: boolean,
}

export function LanguageDialog({ onClose, open }: LanguageDialogProps): ReactElement {
  const { i18n } = useTranslation()
  const [selectedLanguage, setSelectedLanguage] = useState(i18n.language)
  const { t } = useTranslation()
  useEffect(() => {
    if (open) {
      setSelectedLanguage(i18n.language)
    }
  }, [open])
  async function confirm() {
    // TODO(http://jira/browse/SHARE-10): better state indication
    // - Show error when saving to backend fails
    // - While save request pending:
    //     - Show indeterminate progress indicator
    //     - Disable action buttons
    //     - Keep dialog open
    await axios.put('/api/rest/user/settings', { locale: convertForBackend(selectedLanguage) })
    i18n.changeLanguage(selectedLanguage)
    onClose()
  }
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{t('selectLanguage')}</DialogTitle>
      <DialogContent>
        <FormControl fullWidth onKeyPress={event => {
          if (event.key === 'Enter') {
            confirm()
          }
        }}>
          <LanguageDropdown language={selectedLanguage} onChange={lang => setSelectedLanguage(lang)} />
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" auto-qa-id={'LanguageDialog-Cancel'} data-testid={'LanguageDialog-Cancel'}>
          {t('cancel')}
        </Button>
        <Button onClick={confirm} color="secondary" auto-qa-id={'LanguageDialog-Confirm'} data-testid={'LanguageDialog-Confirm'}>
          {t('changeLanguage')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
